import(/* webpackMode: "eager" */ "C:\\git\\clients\\evergreen-strategy-website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\git\\clients\\evergreen-strategy-website\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\git\\clients\\evergreen-strategy-website\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager" */ "C:\\git\\clients\\evergreen-strategy-website\\src\\app\\globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\git\\clients\\evergreen-strategy-website\\src\\components\\layout\\Header.tsx");
